import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import authData from "../../services/authData";
import { axiosVal as axios } from "..";
const getToken = () => "LiveBearer " + localStorage.getItem('auth-token');

const initialState = {
    loaded: false,
    isLoggedin: false,
    progress: false,
    dealers: [],
    mistakes: [],
    total: 0,
    mistakesListData: [],
    studioGamesMap: [],
    groupedMistakes: [],
    resolution: [],
    studios: [],
    reasons: [],
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    }
};

export const getUserMistakes = createAsyncThunk('mistakes/getUserMistakes', async(filters = {}) => {
    const { startDate, endDate, dealer, studio, mistake, status, page, limit } = filters;
    const params = { page, limit };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (dealer && dealer !== 'all') params.dealer = dealer;
    if (studio && studio !== 'all') params.studio = studio;
    if (mistake && mistake !== 'all') params.mistake = mistake;
    if (status) params.status = status;

    const response = await axios.get(
        `/mistakes/`,
        {
            params,
            headers: { 'x-auth': getToken() },
        }
    );

    return response?.data;
});

export const getUserDefaults = createAsyncThunk('mistakes/getUserDefaults', async() => {
    const response = await axios.get(
        `/mistakes/getUserDefaults`,
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );

    return response?.data;
});

export const saveDealerMistake = createAsyncThunk('mistakes/saveDealerMistake', async(data) => {
    const response = await axios.post(
        `/mistakes/saveDealerMistake`,
        data,
        {
            headers: {
                'x-auth': getToken(),
                'Content-Type': 'multipart/form-data'
            },
        }
    );

    return response?.data;
});

export const deleteDealerMistake = createAsyncThunk('mistakes/deleteDealerMistake', async(id) => {
    const response = await axios.delete(
        `/mistakes/${id}`,
        {
            headers: {
                'x-auth': getToken(),
                'Content-Type': 'multipart/form-data'
            },
        }
    );

    return response?.data;
});

export const getDealerMistakes = createAsyncThunk('mistakes/getDealerMistakes', async() => {
    const response = await axios.get(
        `/mistakes/getDealerMistakes`,
        {
            headers: {
                'x-auth': getToken(),
                'Content-Type': 'multipart/form-data'
            },
        }
    );

    return response?.data;
});

export const exportMistake = createAsyncThunk('mistakes/export', async(filters) => {
    const response = await axios.post(
        `/mistakes/export`,
        filters, 
        {
            headers: {
                'x-auth': getToken(),
                'Content-Type': 'application/json'
            },
        }
    );

    return response?.data;
})


const mistakesSlice = createSlice({
    name: "mistakes",
    initialState,
    reducers: {
        reset: (state) => {
            state.success.status = false;
            return state;
        },
        updateDayOffModalStatus(state, action) {
            state.dayOffstatus = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUserDefaults.fulfilled, (state, action) => {
    
            const data = action.payload;
            state.dealers = data?.dealers;
            state.mistakesListData = data?.mistakesListData;
            state.studios = data?.studios;
            state.studioGamesMap = data?.studioGamesMap;
            state.groupedMistakes = data?.groupedMistakes;
            state.resolution = data?.resolution;
        })
        builder.addCase(saveDealerMistake.fulfilled, (state, action) => {
    
            state.success.status = true;
        })
        builder.addCase(getUserMistakes.fulfilled, (state, action) => {
            const payload = action.payload;
            state.mistakes = payload.data ?? payload;
            state.total = payload.total ?? 0;
        })
        builder.addCase(getDealerMistakes.fulfilled, (state, action) => {
            state.dealerMistakes = action.payload;
        })
        builder.addCase(deleteDealerMistake.fulfilled, (state, action) => {
            const payload = action.payload;
            state.mistakes = payload.data ?? payload;
            state.total = payload.total ?? state.total;
        })
        builder.addCase(exportMistake.fulfilled, (state, action) => {
            const csvContent = action.payload;
            
            const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Mistakes_Report_${new Date().toLocaleDateString()}.csv`);
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            window.URL.revokeObjectURL(url);
        });
      
    }
});

export const mistakesActions = mistakesSlice.actions;
export const mistakesReducer = mistakesSlice.reducer;